import SupportedLobModules from 'integration/endorsement/SupportedLobModules';
import CompositeFlowConfig from 'integration/endorsement/config/CompositeFlowConfig';
import 'edge/policycommon/app';

SupportedLobModules.push('edge.policycommon.app');

export default angular.module('edge.endorsement.app', SupportedLobModules).factory('endorsement.CompositeFlowDefn', CompositeFlowConfig);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/app.js
// module id = 334
// module chunks = 0